import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.hr.leave');
import { Input, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-hr-leave',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.hr.leave/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalLpsysadminHrLeaveComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() selfOnly: boolean = false;

    public loaded: boolean = false;
    public activeTab: string = 'request';
    public canManageAll: boolean = false;
    public users: any[] = [];
    public approvers: any[] = [];
    public selectedUserId: string = '';
    public selectedUser: any = {};
    public selectedCompany: string = '';
    public companyOptions: any[] = [];
    public year: number = new Date().getFullYear();
    public balance: any = {};
    public canManagePolicy: boolean = false;
    public policy: any = {};
    public profile: any = {};
    public settings: any = {
        policy: {},
        profile: {},
    };
    public requests: any[] = [];
    public promotionAlerts: any[] = [];
    public legal: any[] = [];
    public defaultApproverIds: string[] = [];
    public form: any = {
        leave_type: 'annual',
        start_date: new Date().toISOString().slice(0, 10),
        end_date: new Date().toISOString().slice(0, 10),
        reason: '',
        handover_note: '',
        emergency_contact: '',
        approver1: '',
        approver2: '',
    };

    public statusMap: any = {
        draft: '임시저장',
        pending: '결재진행',
        approved: '승인완료',
        rejected: '반려',
        withdrawn: '회수',
        revision_requested: '보완요청',
        sent: '발송기록',
        due: '진행필요',
        upcoming: '예정',
        overdue: '기한초과',
    };

    public leaveTypeMap: any = {
        annual: '연차',
        half_am: '오전반차',
        half_pm: '오후반차',
        sick: '병가',
        official: '공가',
        compensatory: '보상휴가',
        family: '가족돌봄',
        maternity: '출산전후휴가',
        paternity: '배우자출산휴가',
    };

    public async ngOnInit() {
        await this.service.init();
        if (!this.selfOnly && !this.isSuperAdmin()) {
            this.service.href('/admin/system/my-leave');
            return;
        }
        await this.load();
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call("load", {
            user_id: this.selfOnly ? '' : this.selectedUserId,
            year: this.year,
            company_name: this.selfOnly ? '' : this.selectedCompany,
            self_only: this.selfOnly ? '1' : '',
        });
        if (code === 200) {
            this.canManageAll = !!data.can_manage_all;
            this.users = data.users || [];
            this.approvers = data.approvers || [];
            this.selectedUserId = data.selected_user_id || '';
            this.selectedUser = data.selected_user || {};
            this.selectedCompany = data.selected_company || this.selectedCompany;
            this.companyOptions = data.company_options || [];
            this.balance = data.balance || {};
            this.canManagePolicy = !!data.can_manage_policy;
            if (!this.canManagePolicy && this.activeTab === 'settings') this.activeTab = 'request';
            this.policy = data.policy || {};
            this.profile = data.profile || {};
            this.settings = {
                policy: { ...this.policy },
                profile: { ...this.profile },
            };
            this.requests = data.requests || [];
            this.promotionAlerts = data.promotion_alerts || [];
            this.legal = data.legal || [];
            this.defaultApproverIds = data.default_approver_ids || [];
            if (!this.form.approver1 && this.defaultApproverIds.length > 0) this.form.approver1 = this.defaultApproverIds[0];
        } else {
            this.service.alert.error(data?.message || "휴가 정보를 불러오지 못했습니다.");
        }
        this.loaded = true;
        await this.service.render();
    }

    public async applyCompanyFilter() {
        if (this.selfOnly) return;
        this.selectedUserId = '';
        this.form.approver1 = '';
        this.form.approver2 = '';
        await this.load();
    }

    public businessDays(): number {
        const start = new Date(this.form.start_date);
        const end = new Date(this.form.end_date);
        if (!this.form.start_date || !this.form.end_date || end < start) return 0;
        if (this.form.leave_type === 'half_am' || this.form.leave_type === 'half_pm') return 0.5;
        let count = 0;
        const cursor = new Date(start);
        while (cursor <= end) {
            const day = cursor.getDay();
            if (day !== 0 && day !== 6) count++;
            cursor.setDate(cursor.getDate() + 1);
        }
        return count;
    }

    public async submitLeave() {
        const approverIds = [this.form.approver1, this.form.approver2].filter((v: string, i: number, arr: string[]) => v && arr.indexOf(v) === i);
        const res = await wiz.call("submit_leave", {
            user_id: this.selfOnly ? '' : this.selectedUserId,
            leave_type: this.form.leave_type,
            start_date: this.form.start_date,
            end_date: this.form.end_date,
            reason: this.form.reason,
            handover_note: this.form.handover_note,
            emergency_contact: this.form.emergency_contact,
            approver_ids: JSON.stringify(approverIds),
            self_only: this.selfOnly ? '1' : '',
        });
        if (res.code === 200) {
            this.service.alert.success("휴가 결재가 상신되었습니다.");
            this.form.reason = '';
            this.form.handover_note = '';
            this.form.emergency_contact = '';
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "휴가 결재 상신에 실패했습니다.");
        }
    }

    public async savePolicy() {
        if (!this.canManagePolicy) return;
        const res = await wiz.call("save_policy", this.settings.policy || {});
        if (res.code === 200) {
            this.service.alert.success("회사 연차 기준이 저장되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "연차 기준 저장에 실패했습니다.");
        }
    }

    public async saveProfile() {
        if (!this.canManagePolicy) return;
        const res = await wiz.call("save_profile", {
            user_id: this.selectedUserId,
            ...(this.settings.profile || {}),
        });
        if (res.code === 200) {
            this.service.alert.success("직원별 연차 기준이 저장되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "직원별 기준 저장에 실패했습니다.");
        }
    }

    public async recordNotice(item: any) {
        if (!this.canManagePolicy) return;
        const res = await wiz.call("record_notice", {
            user_id: this.selectedUserId,
            year: this.year,
            stage: item.stage,
        });
        if (res.code === 200) {
            this.service.alert.success("연차 사용촉진 알림 발송 기록이 저장되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "알림 기록 저장에 실패했습니다.");
        }
    }

    public openApproval(item: any) {
        if (!item.approval_id) return;
        this.service.href(`/admin/system/approval/${item.approval_id}`);
    }

    public openPersonnelRecord() {
        this.service.href(`/admin/system/hr-records`);
    }

    public isSuperAdmin(): boolean {
        return this.service.auth?.session?.membership === 'super_admin';
    }

    public pageTitle(): string {
        return this.selfOnly ? '내 휴가관리' : '휴가관리';
    }

    public pageDescription(): string {
        return this.selfOnly ? '내 휴가 신청, 결재 진행, 잔여 연차를 확인합니다.' : '휴가 신청, 결재 진행, 잔여 연차, 연차 기준, 연차 사용촉진 알림을 관리합니다.';
    }

    public statusClass(status: string): string {
        const map: any = {
            draft: 'bg-zinc-100 text-zinc-600',
            pending: 'bg-yellow-100 text-yellow-700',
            approved: 'bg-emerald-100 text-emerald-700',
            rejected: 'bg-red-100 text-red-700',
            withdrawn: 'bg-zinc-100 text-zinc-500',
            revision_requested: 'bg-orange-100 text-orange-700',
            sent: 'bg-blue-100 text-blue-700',
            due: 'bg-amber-100 text-amber-700',
            upcoming: 'bg-zinc-100 text-zinc-500',
            overdue: 'bg-red-100 text-red-700',
        };
        return map[status] || 'bg-zinc-100 text-zinc-600';
    }

    public basisLabel(value: string): string {
        const map: any = {
            fiscal_year: '회계연도 기준',
            hire_date: '입사일 기준',
            company_policy: '회사 기본 기준',
        };
        return map[value] || value || '-';
    }

    public dayLabel(value: any): string {
        const num = Number(value || 0);
        return `${Number.isInteger(num) ? num : num.toFixed(1)}일`;
    }
}

export default PortalLpsysadminHrLeaveComponent;